var exports = {
  "Qs": "AddConnectionModal.module__content___SWluSD",
  "t$": "AddConnectionModal.module__stack___SWluSD",
  "GA": "AddConnectionModal.module__instructions___SWluSD",
  "G5": "AddConnectionModal.module__dnsCard___SWluSD",
  "KJ": "AddConnectionModal.module__dnsHeading___SWluSD",
  "Eq": "AddConnectionModal.module__dnsTitle___SWluSD",
  "h_": "AddConnectionModal.module__dnsFields___SWluSD",
  "ti": "AddConnectionModal.module__inlineCode___SWluSD",
  "_c": "AddConnectionModal.module__dnsInput___SWluSD",
  "x": "AddConnectionModal.module__orDivider___SWluSD",
  "LC": "AddConnectionModal.module__orDividerLine___SWluSD",
  "AS": "AddConnectionModal.module__orDividerText___SWluSD",
  "iW": "AddConnectionModal.module__tokenCard___SWluSD",
  "TN": "AddConnectionModal.module__tokenCardHeader___SWluSD",
  "q6": "AddConnectionModal.module__tokenTitle___SWluSD",
  "wc": "AddConnectionModal.module__tokenSubtitle___SWluSD",
  "OB": "AddConnectionModal.module__tokenDownloadRow___SWluSD",
  "RB": "AddConnectionModal.module__tokenMeta___SWluSD",
  "cL": "AddConnectionModal.module__copyButton___SWluSD",
  "nJ": "AddConnectionModal.module__copyIcon___SWluSD",
  "y5": "AddConnectionModal.module__providerPanel___SWluSD",
  "SA": "AddConnectionModal.module__providerTile___SWluSD",
};

module.exports = exports;
